export default {
  button: {
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    cancel: 'Cancel',
    clear: 'Clear',
    back: 'Back',
    export: 'Export',
    lang:'English'
  },
  navbar :{
    profile : 'information',
    logOut: 'loginout',
    updatePwd: 'change password'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js